<zenith-form-group>
  @if (label()) {
    <zenith-form-group-label>
      {{ label() | translate }}
    </zenith-form-group-label>
  }

  <zenith-input-number
    [formControl]="control()"
    [attr.zn-name]="name()"
    [attr.zn-show-controls]="showControls()"
    [attr.zn-step]="step()"
    [attr.zn-suffix]="suffix()"
    [attr.zn-autofocus]="autofocus()"
    [attr.zn-invalid]="control() | invalidAsync | async"
  />
  @if (hint()) {
    <zenith-form-group-hint>{{ hint() }}</zenith-form-group-hint>
  }

  <custom-zenith-form-group-error [control]="control()" />
</zenith-form-group>



